import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

// Dashboard sayfalarında üst sıradaki istatistik grid'lerinde kullanılan
// standart metrik kartı. İki varyant:
//   - 'border' (default): sol kenarlı renkli şerit, sola yaslanmış sayı+etiket
//   - 'center': merkezli ikon + büyük sayı + etiket
//
// color: 'primary' | 'emerald' | 'amber' | 'red' | 'blue' | 'rose' | 'indigo'
const COLOR_MAP = {
  primary: { border: 'border-l-primary', text: 'text-primary' },
  emerald: { border: 'border-l-emerald-500', text: 'text-emerald-500' },
  amber: { border: 'border-l-amber-500', text: 'text-amber-500' },
  red: { border: 'border-l-red-500', text: 'text-red-500' },
  blue: { border: 'border-l-blue-500', text: 'text-blue-500' },
  rose: { border: 'border-l-rose-500', text: 'text-rose-500' },
  indigo: { border: 'border-l-indigo-500', text: 'text-indigo-500' },
  muted: { border: 'border-l-muted-foreground/40', text: '' },
};

export default function StatCard({
  value,
  label,
  color = 'muted',
  icon: Icon,
  variant = 'border',
  className = '',
  'data-testid': testId,
}) {
  const colorClass = COLOR_MAP[color] || COLOR_MAP.muted;

  if (variant === 'center') {
    return (
      <Card className={className} data-testid={testId}>
        <CardContent className="p-5 text-center">
          {Icon && <Icon className={`w-8 h-8 mx-auto mb-2 ${colorClass.text}`} />}
          <div className={`text-3xl font-bold ${colorClass.text}`}>{value}</div>
          <div className="text-xs text-muted-foreground mt-1">{label}</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={`border-l-4 ${colorClass.border} ${className}`} data-testid={testId}>
      <CardContent className="p-4">
        <div className={`text-2xl font-bold ${color !== 'muted' ? colorClass.text : ''}`}>{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
      </CardContent>
    </Card>
  );
}
